import { Map, List } from 'immutable';
import {
  FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS,
  FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS,
  FETCH_IDP_LEARNING_RESULT_SUCCESS,
  FETCH_IDP_FEEDBACK_SUGGESTIONS_SUCCESS,
  FETCH_IDP_APPROVAL_LIST_SUCCESS,
  FETCH_IDP_PARTICIPATION_SUCCESS,
} from './actions';
import IdpListModel from './IdpList';
import GroupIdpListModel from './GroupIdpList';
import IndividualDevelopmentPlanModel from './Idp';
import SuggestionsModel from './Idp/Suggestions';
import IdpApprovalListModel from './IdpApprovalList';
import idpParticipationModel from './IdpParticipation';

export function individualDevelopmentPlanList(state = new Map(), action) {
  switch (action.type) {
    case FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS:
      return onGroupIdpListSuccess(state, action);
    case FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS:
      return state.update(action.groupIdpId, (groupIdp) => onIdpListSuccess(groupIdp, action));
    default:
      return state;
  }
}

function onGroupIdpListSuccess(state, action) {
  let result = state;
  action.payload.forEach((groupIdp) => {
    result = result.set(groupIdp.id, GroupIdpListModel
        .create(groupIdp)
        .set('groupId', action.groupId));
  });
  return result;
}

function onIdpListSuccess(groupIdp, action) {
  if (! groupIdp) return;
  return groupIdp.set('idpList', createIdpList(action.payload));
}

function createIdpList(idpList) {
  let result = new List();
  idpList.forEach((idpItem) => {
    result = result.push(IdpListModel.create(idpItem));
  });
  return result;
}

export function individualDevelopmentPlan(state = new Map(), action) {
  switch (action.type) {
    case FETCH_IDP_LEARNING_RESULT_SUCCESS:
      return state.update(action.idpId, (originIdp) =>
        onIdpLearningResultSuccess(originIdp, action));
    case FETCH_IDP_FEEDBACK_SUGGESTIONS_SUCCESS:
      return state.update(action.idpId, (originIdp) =>
        onIdpFeedbackSuggestionsSuccess(originIdp, action));
    default:
      return state;
  }
}

function onIdpLearningResultSuccess(originIdp = new IndividualDevelopmentPlanModel(), action) {
  let learningResult = IndividualDevelopmentPlanModel.create(action.payload);
  learningResult = {
    id: learningResult.id,
    studentId: learningResult.studentId,
    period: learningResult.period,
    learningResult: learningResult.learningResult,
    dosRejectedComment: learningResult.dosRejectedComment,
    lastUpdatedTimeUtc: learningResult.lastUpdatedTimeUtc,
  };
  return originIdp.merge(learningResult);
}

function onIdpFeedbackSuggestionsSuccess(
    originIdp = new IndividualDevelopmentPlanModel(), action) {
  const suggestions = { studentIDPFeedbackSuggestions: SuggestionsModel.create(action.payload) };
  return originIdp.merge(suggestions);
}

export function idpApprovalList(state = new Map(), action) {
  switch (action.type) {
    case FETCH_IDP_APPROVAL_LIST_SUCCESS:
      return state.set(action.groupIdpId, new List(action.payload.map((idpApproval) =>
          IdpApprovalListModel.create(idpApproval))));
    default:
      return state;
  }
}

export function idpParticipation(state = new Map(), action) {
  switch (action.type) {
    case FETCH_IDP_PARTICIPATION_SUCCESS:
      return action.payload.reduce((participationMap, item) =>
          participationMap.set(`${item.id}`, idpParticipationModel.create(item)), Map());
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/reducer.js